import { createAsyncThunk } from '@reduxjs/toolkit';
import { calendarOpenNextWeek } from '../actions/demoActions';
import { selectIsAdminInSelectedProject } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { loadCalendarDataInTimeframe } from './loadCalendarDataInTimeframe.thunk';
import dayjs from 'dayjs';
import {
  selectFetchedWeekNumbers,
  selectWorkSearchParamsVisibleWeeks,
} from '../selectors/workSearchParamsSelectors';
import { loadPersonalWorkCalendarData } from './my-lixani/loadPersonalWorkCalendarData.thunk';
import { selectIsPersonalWorkCalendarMode } from '../selectors/base-work-calendar.selectors';
import { loadAdminCalendarRecordsDataInTimeframe } from './loadAdminCalendarRecordsDataInTimeframe.thunk';
import { loadAdminCalendarFilesDataInTimeframe } from './loadAdminCalendarFilesDataInTimeframe.thunk';

export const setOpenNextWeek = createAsyncThunk(
  'workCalendar/setOpenNextWeek',
  async (_, { dispatch, getState }) => {
    const state = getState();

    const isAdminInSelectedProject = selectIsAdminInSelectedProject(state);

    const visibleWeeks = selectWorkSearchParamsVisibleWeeks(state);

    const fetchedWeeks = selectFetchedWeekNumbers(state);

    const isPersonalWorkCalendarMode = selectIsPersonalWorkCalendarMode(state);

    const weekISO =
      visibleWeeks.length > 0
        ? visibleWeeks[visibleWeeks.length - 1]
        : dayjs().startOf('isoWeek').format();

    const nextWeek = dayjs(weekISO).add(1, 'week').format();

    const nextWeekNumber = dayjs(nextWeek).format('GGGG[W]WW').split('W')[1];

    dispatch(calendarOpenNextWeek(nextWeek));

    if (!fetchedWeeks.includes(nextWeekNumber)) {
      if (isPersonalWorkCalendarMode) {
        await dispatch(loadPersonalWorkCalendarData());
      } else if (isAdminInSelectedProject) {
        await Promise.allSettled([
          dispatch(loadAdminCalendarRecordsDataInTimeframe()),
          dispatch(loadAdminCalendarFilesDataInTimeframe()),
        ]);
      } else {
        await dispatch(loadCalendarDataInTimeframe());
      }
    }
  }
);
